var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListSettingsLine = function SvgListSettingsLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 17.4h6.3v1.8H3.5zm0-6.3h8.1v1.8H3.5zm0-6.3h18v1.8h-18zm16.807 8.123 1.04-.352.9 1.56-.824.724c.103.492.103 1 0 1.492l.824.724-.9 1.56-1.04-.353c-.37.333-.809.59-1.292.747l-.215 1.076H17l-.216-1.077a3.6 3.6 0 0 1-1.29-.747l-1.041.353-.9-1.559.824-.724a3.6 3.6 0 0 1 0-1.492l-.824-.725.9-1.559 1.04.352c.37-.333.809-.59 1.292-.747L17 11.101h1.8l.216 1.076c.482.157.922.414 1.29.747ZM17.9 17.401a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6"
  })));
};
export default SvgListSettingsLine;